import React from "react";
import Datetime from "react-datetime";
import ClassNames from "classnames";
import { has } from "lodash";

export default class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      place: props.place || {},
      notes: props.notes || '',
      availability: props.availability || '',
      cardFront: props.cardFront || '',
      cardBack: props.cardBack || '',
      submitting: true
    };

    this.notesRef = React.createRef();
    this.availabilityRef = React.createRef();
    this.cardFrontRef = React.createRef();
    this.cardBackRef = React.createRef();
    this.nameRef = React.createRef();
    this.addressRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.place !== this.props.place) {
      var newPlace = Object.assign({}, this.state.place, this.props.place);
      this.setState({ place: newPlace });
    }
  }

  submit() {
    this.setState({ submitting: false });
    this.props.onSubmit(
      Object.assign({}, this.state, {
        notes: this.notesRef.current.value,
        availability: this.availabilityRef.current.value
      }),
      this.cardFrontRef.current.files[0],
      this.cardBackRef.current.files[0]
    );
  }

  onChange() {
    var newPlace = Object.assign({}, this.state.place, {
      name: this.nameRef.current.value,
      vicinity: this.addressRef.current.value
    });
    this.setState({
      place: newPlace,
      availability: this.availabilityRef.current.value
    });
  }

  render() {
    let noteProps = { className: "input", type: "text", ref: this.notesRef, rows: 5 };
    if (this.state.notes) {
      noteProps.defaultValue = this.state.notes;
    }

    const frontLabel = this.state.cardFront
      ? "Front of Business Card, already uploaded - only select if you want to override first upload"
      : "Front of Business Card";

    const backLabel = this.state.cardBack
      ? "Back of Business Card, already uploaded - only select if you want to override first upload"
      : "Back of Business Card";

    const hasNameError = has(this.props.errors, "name") && !this.state.place.name;

    return (
      <div>
        <div className="field">
          <label className="label">Name</label>
          <div className="control">
            <input
              className={ClassNames({
                "is-danger": hasNameError,
                input: true
              })}
              type="text"
              ref={this.nameRef}
              value={this.state.place.name}
              onChange={this.onChange.bind(this)}
            />
          </div>
          {hasNameError && <p className="help is-danger">{this.props.errors["name"]}</p>}
        </div>

        <div className="field">
          <label className="label">Address</label>
          <div className="control">
            <input
              className="input"
              type="text"
              ref={this.addressRef}
              value={this.state.place.vicinity}
              onChange={this.onChange.bind(this)}
            />
          </div>
        </div>

        <div className="field">
          <label className="label">Notes</label>
          <div className="control">
            <textarea {...noteProps} />
          </div>
        </div>

        <div className="field">
          <label className="label">Owner Availability</label>
          <div className="control">
            <input
              className="input"
              type="text"
              ref={this.availabilityRef}
              value={this.state.availability}
              onChange={this.onChange.bind(this)}
            />
          </div>
        </div>

        <div className="field">
          <label className="label">{frontLabel}</label>
          <input className="input" type="file" ref={this.cardFrontRef} />
        </div>

        <div className="field">
          <label className="label"> {backLabel}</label>
          <input className="input" type="file" ref={this.cardBackRef} />
        </div>

        <div className="field">
          <div className="control">
            <button
              className="button is-primary"
              disabled={!this.state.submitting}
              onClick={this.submit.bind(this)}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  }
}
